import CancelIcon from "../../assets/icons/under-construction.svg";
import AlertPage from "./AlertPage";

const Forbidden = ({ message }) =>
  AlertPage({
    title: "Forbidden",
    icon: CancelIcon,
    message,
  });

export default Forbidden;
